import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Navbar from "./Navbar";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "../Pages/HomePage/HomePage";
import { BranchContextProvider } from "../Context/BranchContext";
import { BranchDistrictContextProvider } from "../Context/BranchDistrictContext";
import { BranchRegionContextProvider } from "../Context/BranchRegionContext";
import { BranchDivisionContextProvider } from "../Context/BranchDivisionContext";
import BranchPage from "../Pages/Branch/BranchPage";
import BranchForm from "../Pages/Branch/BranchForm/BranchForm";
import SingleBranchView from "../Pages/Branch/SingleBranchPage";
import BranchDistrictPage from "../Pages/BranchDistrict/BranchDistrictPage";
import BranchDivisionPage from "../Pages/BranchDivision/BranchDivisionPage";
import BranchRegionPage from "../Pages/BranchRegion/BranchRegionPage";
import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import { SignInButton } from "./SignInButton";
import RequestInterceptor from "./RequestInterceptor";

type Props = {
  publicClientApp: IPublicClientApplication;
};

function App({ publicClientApp }: Props) {
  return (
    <MsalProvider instance={publicClientApp}>
      <UnauthenticatedTemplate>
        <SignInButton />
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <RequestInterceptor>
          <Pages />
        </RequestInterceptor>
      </AuthenticatedTemplate>
    </MsalProvider>
  );
}

function Pages() {
  return (
    <BranchDivisionContextProvider>
      <BranchRegionContextProvider>
        <BranchDistrictContextProvider>
          <BranchContextProvider>
            <Router>
              <Navbar />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/branch-table" element={<BranchPage />} />
                <Route
                  path="/branch-table/:BranchId"
                  element={<SingleBranchView />}
                />
                <Route
                  path="/branch-district"
                  element={<BranchDistrictPage />}
                />
                <Route path="/branch-form" element={<BranchForm />} />
                <Route
                  path="/branch-division"
                  element={<BranchDivisionPage />}
                />
                <Route path="/branch-region" element={<BranchRegionPage />} />
              </Routes>
            </Router>
          </BranchContextProvider>
        </BranchDistrictContextProvider>
      </BranchRegionContextProvider>
    </BranchDivisionContextProvider>
  );
}

export default App;
